;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { successMessageVar, SnackbarMessageState } from "../../reactiveVars"

type SuccessMessageInput = string | SnackbarMessageState | null

export default function updateSuccessMessage(
  successMessage: SuccessMessageInput,
): void {
  if (typeof successMessage === "string") {
    successMessageVar({
      message: successMessage,
      duration: 3000,
    })
    return
  }

  if (successMessage === null) {
    successMessageVar(successMessage)
    return
  }

  if (successMessage.message && successMessage.duration) {
    successMessageVar(successMessage)
    return
  }

  throw new Error("Invalid successMessage format")
}
